import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import {
    Modal,
    Fade,
    Card,
    TextField,
    Button,
    Typography,
    Box,
    InputLabel,
} from "@mui/material";
import { gql, useMutation } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { MessageManager } from "context";
import { UserContext } from "context/user";
import SoftInputNumber from "components/SoftInputNumberUpgrade";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

export default function ModalEditarLimites({ open, onClose, menuItem, onRefetch }) {
    const [limiteVM, setLimiteVM] = useState("");
    const [limiteReservasSedeC, setLimiteCentenario] = useState("");
    const [limiteReservasSedeTR, setLimiteTerceraRotonda] = useState("");
    const [limiteReservasSedeSP, setLimiteSerranias] = useState("");
    const { handleSnackbar } = useContext(MessageManager);
    const { user } = useContext(UserContext);

    // Mutation para actualizar límites de reservas
    const [updateMenuDelDia, { loading }] = useMutation(
        gql`
      mutation saveMenuDelDia($input: MenuDelDiaInput!) {
        saveMenuDelDia(input: $input) {
          id
          limiteReservas
          limiteReservasSedeC
          limiteReservasSedeTR
          limiteReservasSedeSP
        }
      }
    `,
        {
            onCompleted: () => {
                handleSnackbar("Límites actualizados correctamente", "success");
                onRefetch();
                onClose();
            },
            onError: (error) => {
                handleSnackbar("Error al actualizar los límites", "error");
                console.error("Error:", error);
            },
        }
    );

    useEffect(() => {
        if (open && menuItem) {
            setLimiteVM(menuItem.limiteReservas || "");
            setLimiteCentenario(menuItem.limiteReservasSedeC || "");
            setLimiteSerranias(menuItem.limiteReservasSedeSP || "");
            setLimiteTerceraRotonda(menuItem.limiteReservasSedeTR || "");
        }
    }, [open, menuItem]);

    const handleSave = () => {
        if (!menuItem?.id) return;

        const input = {
            id: menuItem.id,
            idProducto: menuItem.idProducto,
            nombre: menuItem.title,
            fechaMenu: menuItem.date,
            turno: menuItem.turno,
        };

        // Solo actualizar el campo que corresponde según la sede del usuario
        if (user?.sede?.id == 1) {
            input.limiteReservas = parseInt(limiteVM) || 0;
            input.limiteReservasSedeSL = menuItem.limiteReservasSedeSL; // Mantener el valor actual
        } else if (user?.sede?.id == 2) {
            input.limiteReservas = menuItem.limiteReservas; // Mantener el valor actual
            input.limiteReservasSedeSP = parseInt(limiteReservasSedeSP) || 0;
            input.limiteReservasSedeTR = parseInt(limiteReservasSedeTR) || 0;
            input.limiteReservasSedeC = parseInt(limiteReservasSedeC) || 0;
        }

        updateMenuDelDia({
            variables: { input },
        });
    };

    const handleCancel = () => {
        setLimiteVM(menuItem.limiteReservas || "");
        setLimiteCentenario(menuItem.limiteReservasSedeC || "");
        setLimiteSerranias(menuItem.limiteReservasSedeSP || "");
        setLimiteTerceraRotonda(menuItem.limiteReservasSedeTR || "");
        onClose();
    };

    console.log('user', user)

    const isSedeVM = user?.sede?.id == 1;
    const isSedeSL = user?.sede?.id == 2;

    return (
        <Modal open={open} onClose={onClose} closeAfterTransition>
            <Fade in={open}>
                <Card sx={style}>
                    <SoftBox>
                        <SoftTypography variant="h6" fontWeight="bold" mb={3}>
                            Editar límites de reservas
                        </SoftTypography>

                        <SoftBox display="flex" flexDirection="column" gap={2}>
                            {isSedeVM && (<SoftBox>
                                <InputLabel htmlFor="limiteVM">
                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        Límite de reservas VM:
                                    </SoftTypography>
                                </InputLabel>
                                <SoftInputNumber
                                    placeholder="Límite de reservas Villa Mercedes"
                                    variant="outlined"
                                    onChange={(e) => setLimiteVM(e.target.value)}
                                    value={limiteVM}
                                    disabled={!isSedeVM}
                                />
                            </SoftBox>)}

                            {isSedeSL && (<> <SoftBox>
                                <InputLabel htmlFor="limiteSL">
                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        Límite de reservas Serranías Puntanas:
                                    </SoftTypography>
                                </InputLabel>
                                <SoftInputNumber
                                    placeholder="Límite de reservas Serranías Puntanas"
                                    variant="outlined"
                                    onChange={(e) => setLimiteSerranias(e.target.value)}
                                    value={limiteReservasSedeSP}
                                    disabled={!isSedeSL}
                                />
                            </SoftBox>

                                <SoftBox>
                                    <InputLabel>
                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                            Límite de reservas Tercera Rotonda:
                                        </SoftTypography>
                                    </InputLabel>
                                    <SoftInputNumber
                                        placeholder="Límite de reservas Tercera Rotonda"
                                        variant="outlined"
                                        onChange={(e) => setLimiteTerceraRotonda(e.target.value)}
                                        value={limiteReservasSedeTR}
                                        disabled={!isSedeSL}
                                    />
                                </SoftBox>

                                <SoftBox>
                                    <InputLabel htmlFor="limiteSL">
                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                            Límite de reservas Centenario:
                                        </SoftTypography>
                                    </InputLabel>
                                    <SoftInputNumber
                                        placeholder="Límite de reservas Centenario"
                                        variant="outlined"
                                        onChange={(e) => setLimiteCentenario(e.target.value)}
                                        value={limiteReservasSedeC}
                                        disabled={!isSedeSL}
                                    />
                                </SoftBox></>)}

                            <SoftBox display="flex" justifyContent="space-between" mt={2}>
                                <SoftButton
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCancel}
                                    disabled={loading}
                                >
                                    Cancelar
                                </SoftButton>
                                <SoftButton
                                    color="uproGreen"
                                    onClick={handleSave}
                                    disabled={loading || (!isSedeVM && !isSedeSL)}
                                >
                                    Guardar
                                </SoftButton>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </Card>
            </Fade>
        </Modal>
    );
}

ModalEditarLimites.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    menuItem: PropTypes.object,
    onRefetch: PropTypes.func.isRequired,
};
